module.exports = __webpack_public_path__ + "e7aa9c0c2e3a9ed2235d283d7ddc1123.svg";